module.exports = __webpack_public_path__ + "img/82.dc7a5f17.jpg";